export default __webpack_public_path__ + "assets/webgl/scene-19.4173a676.glb";